import SttInput from "../../components/SttInput";
import React, {Fragment} from "react";
import StepHeader from "../StepHeader";
import ReadOnlyField from "../../ReadOnlyField";
import AppContext from "../../AppContext";

export default class Claim extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.identifier = "claim";
    }

    render() {
        return (
            <Fragment>
                <StepHeader section={this.props.section} tooltipTitle={true}/>
                <h2>Essential Question</h2>
                <ReadOnlyField identifier="essentialquestion" className="box bg-autofill" />
                { this.context.canEdit ?
                    <Fragment>
                        <div className="box box-primary">
                            <SttInput {...this.props} inputType={"text-area"} identifier={this.identifier} addImage={false} singleLine={false} />
                        </div>
                        <div className="box box-primary">
                            <SttInput {...this.props} inputType={"text-area"} identifier={"claimcontext"} addImage={true} singleLine={false} />
                        </div>
                    </Fragment>
                :
                    <Fragment>
                        <ReadOnlyField identifier={this.identifier} className="box bg-autofill" />
                        <div className={"box bg-autofill"} >
                            <div className={"row"}>
                                <ReadOnlyField identifier={"claimcontext"} className={"grouping-text"} />
                                <ReadOnlyField identifier={"claimcontext/image"} className={"grouping-img"} />
                            </div>
                        </div>
                    </Fragment>

                }
            </Fragment>
        );
    }

}
